import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { Subject } from '../../../../models'

@Component({
  selector: 'app-search-bar-com',
  templateUrl: 'search-bar.com.html'
})

export class SearchBarComponent implements OnInit {

  form: FormGroup
  typing = new Subject<string>()
  @Input() words: string = null
  @Input() limit = 10
  @Input() limits: number[] = [10, 20, 30, 40, 50, 100, 200, 500]
  @Input() label: string = null
  @Output() event = new EventEmitter()

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.buildForm()
    this.listenToSearch()
    this.event.emit({ source: 'search', action: 'initialize', data: {
      words: this.words,
      limit: this.limit
    }})
  }

  private buildForm() {
    this.form = this.fb.group({
      words: this.words,
      limit: this.limit
    })
  }

  public listenToSearch() {
    this.typing.debounceTime(400).distinctUntilChanged().subscribe(words => {
      this.event.emit({
        source: 'search',
        action: 'change-words',
        data: {
          words: words.trim(),
          limit: this.form.value.limit === '全部' ? null : this.form.value.limit
        }
      })
    })
  }

  public changeLimit() {
    this.event.emit({
      source: 'search',
      action: 'change-limit',
      data: {
        words: this.form.value.words ? this.form.value.words.trim() : null,
        limit: this.form.value.limit === '全部' ? null : this.form.value.limit
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/forms/search-bar/search-bar.com.ts